import { Box, CircularProgress, Typography } from "@mui/material";
import { spinnerStore } from "../../context/spinnerStore";

export default function GlobalSpinner() {
  const { isLoading, loadingText } = spinnerStore();

  if (!isLoading) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Fondo semitransparente para bloquear clicks
        zIndex: 1301, // Asegurarse que esté por encima de otros elementos
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
      {loadingText && (
        <Typography variant="h6" sx={{ mt: 2, color: "#ffffff" }}>
          {loadingText}
        </Typography>
      )}
    </Box>
  );
}
